
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import OCROrderApi from "@/api/ocr-order-api";
import ItemView from "./item-view.vue";
import OcrOrder from "./config"
import UploadApi from "@/api/upload-api";
import { resolveDownloadUrl } from "@/assets/scripts/utils/urls";
import { Dialog, ImagePreview, Toast } from "vant";
import eventBus from "@/utils/event-bus";
import Config from "./config"
import ListTable from "./list-table.vue"
import ItemEditor from "./item-editor.vue";
import CustomUploadApi from "@/api/custom-upload";
const enum TabType {
    All,
    Comfirm,
    UnComfirm
}

type MainType = OcrOrder.IOcrOrderListItemWithDetail & { cover?: string }
@Component({ name: "index", components: { ItemView, ListTable, ItemEditor } })
export default class index extends Vue {
    webResult: MainType = {} as any
    tabIdx: TabType = 0
    converFiles: UploadApi.IFileDetailView[] = []
    query = { Type: OCROrderApi.KeyType.PartNo, Keyword: "" } as OCROrderApi.IOCROrderQuery
    systemOrderEditor = {
        dlgShow: false,
        item: {} as { Id: number }
    }
    getDateTime = Config.getDateTime

    created() { }
    mounted() {
        const id = parseInt(this.$route.query.id as any)
        OCROrderApi.getDetail(id).then(e => this.onData(e as MainType))
        eventBus.emit("set-nav-right", { title: "导出", onClick: this.doExport, icon: "share" })

        var type = Number(this.$route.query.type) as OCROrderApi.KeyType;
        var word = this.$route.query.keyword as string
        if (!this.keywordType.some(e => e.value == type)) return;

        this.query.Type = type;
        this.query.Keyword = word;
    }

    async onData(item: MainType) {
        eventBus.emit("upate-nav-title", item.OrderNo!);
        const lines = item.Detail as OcrOrder.DetailItem[];
        lines.forEach((e, idx) => {
            e.files = [];
            (e as any).RowIndex = idx + 1;
        });
        this.webResult = item;
        UploadApi.getFiles({ RelationId: item.Id, RelationType: Config.UploadFiles.hk_receipt_order_goods }).then(e => {
            if (!e.length) return;
            this.$set(this.webResult, "cover", CustomUploadApi.getFileUrl(e[0].Id!));
        })
    }

    async doExport() {
        const isWeChat = /MicroMessenger/i.test(navigator.userAgent);
        Toast.loading({ message: '正在生成文件...', forbidClick: true, })
        const fileId = await OCROrderApi.exportExcel({ ...this.query, Id: this.webResult.Id }).finally(() => Toast.clear());
        const url = CustomUploadApi.getExportFileUrl(fileId!)
        if (!isWeChat) return window.open(url, "_blank");

        // 在微信环境中，弹出确认对话框
        await Dialog.alert({
            title: '提示',
            message: `请复制此链接到外部浏览器打开<br><span class='blue'>${url}</span>`,
            allowHtml: true,
            confirmButtonText: "点击复制"
        })

        navigator.clipboard.writeText(url).then(() => {
            Toast.success('链接已复制到剪贴板');
        })
    }

    get keywordType() {
        const options = [{ text: "型号", value: OCROrderApi.KeyType.PartNo }, { text: "箱号", value: OCROrderApi.KeyType.CartonNo }, { "text": "备注", value: OCROrderApi.KeyType.DetailRemark }]
        if (this.webResult.IsCustom) {
            options.push({ "text": "货架", value: OCROrderApi.KeyType.PalletNo })
        }
        return options;
    }
    get photos() { return -1 }
    get tableDataSoure() {
        switch (this.tabIdx) {
            case TabType.UnComfirm: return this.itemSourceUnconfirmed;
            case TabType.Comfirm: return this.itemSourceConfirmed;
            default: return this.itemSource;
        }
    }

    get itemSource() {
        var list: OcrOrder.DetailItem[] = this.webResult.Detail || [];
        if (!this.query.Keyword) return list;

        var field: keyof OcrOrder.DetailItem;
        var isFull = false;

        switch (this.query.Type) {
            case OCROrderApi.KeyType.PartNo: field = "PartNo"; break;
            case OCROrderApi.KeyType.DetailRemark: field = "UserRemark"; break;

            case OCROrderApi.KeyType.CartonNo: field = "CaseNo"; isFull = true; break;
            case OCROrderApi.KeyType.PalletNo: field = "PalletNo"; isFull = true; break;
            default: return list;
        }
        const keyword = this.query.Keyword.toUpperCase();
        return list.filter(e => {
            var val = e[field];
            if (!val) return false;
            var str = val.toString().toUpperCase();
            if (isFull) return str == keyword;
            return (str.includes(keyword))
        })
    }

    get itemSourceConfirmed() { return this.itemSource.filter(e => e.CheckStatus); }
    get itemSourceUnconfirmed() { return this.itemSource.filter(e => !e.CheckStatus); }
    doEdit() {
        this.$router.push({ name: 'ocr-order-editor', query: { id: this.webResult.Id } as any })
    }
    async doDel() {
        await Dialog.confirm({ message: "是否要删除该OCR理货明细？" });
        await OCROrderApi.del(this.webResult.Id)
        Toast({ message: "删除成功" });
        this.$router.replace({ name: "ocr-order-list" });
    }
    rowClick(m: MainType) {
        if (this.webResult.IsCustom) {
            this.$router.push({
                name: "ocr-order-detail-customer-editor",
                query: { id: m.Id, orderId: this.webResult.Id } as any
            })
            return;
        }
        this.systemOrderEditor.item = m;
        this.systemOrderEditor.dlgShow = true;
    }

    editOnSwipe(step: number) {
        var idx = this.tableDataSoure.findIndex(e => e.Id == this.systemOrderEditor.item.Id);
        idx += step;
        if (step > 0) {
            if (idx >= this.tableDataSoure.length) return Toast({ message: "已是最后一项", icon: "fail" });
        }
        else if (idx < 0) return Toast({ message: "已是最第一项", icon: "fail" });
        this.systemOrderEditor.item = this.tableDataSoure[idx];
    }
    showPreview() {
        if (!this.webResult.cover) return;
        ImagePreview([this.webResult.cover])
    }
}
